console.log ('accessibilty');
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('a[target="_blank"]').forEach((link) => {
      const linkText = 
        link.getAttribute('aria-label') || 
        link.innerText.trim() || 
        link.getAttribute('title') || 
        'link';
  
      link.setAttribute('aria-label', `${linkText} - this link opens in a new tab`);
      link.setAttribute('rel', 'noopener noreferrer');
    });
  });